export default function Settings() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="mt-2 text-gray-600">Application settings and configuration</p>
      </div>

      <div className="card">
        <h2 className="text-xl font-semibold mb-4">Application Settings</h2>
        <p className="text-gray-600">Settings functionality coming soon...</p>
      </div>
    </div>
  );
}

